import LanguageSelector from 'Components/Header/Components/LanguageSelector/LanguageSelector';

export default LanguageSelector;
